import { get, slice, reduce, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { SecondaryHeading } from 'components/Headings';
import { Small, Medium, LargeUp } from 'components/MediaQuery';
import { MODULE_TYPES } from 'constants/homepage';
import { mediumUp, largeUp } from 'constants/mediaQueries';
import CategoryCarouselHero from 'models/CategoryCarousel';
import Theme from 'styles/theme';

import DesktopCategories from './DesktopCategories';
import MobileCarousel from './MobileCarousel';

class CategoryCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCategoryIndex: 0,
      activeSlideIndex: 0,
    };
  }

  handleCategorySelect = index => {
    const { activeCategoryIndex } = this.state;
    if (activeCategoryIndex === index) return;

    const activeSlideIndex = this.findSlideIndexByCategoryIndex(index);

    this.setState({
      activeCategoryIndex: index,
      activeSlideIndex,
    });
  };

  handleSlideSelect = (slideIndex, categoryIndex) => {
    this.setState({ activeSlideIndex: slideIndex, activeCategoryIndex: categoryIndex });
  };

  findSlideIndexByCategoryIndex = categoryIndex => {
    const { data } = this.props;

    return reduce(
      slice(data.categories, 0, categoryIndex),
      (sum, category) => {
        const slideCount = get(category, ['categoryCards', 'length'], 0);
        return sum + slideCount;
      },
      0
    );
  };

  trackCTAClick = (url, label, categoryIndex, productCardIndex) => {
    const { data, homepagePosition } = this.props;
    const category = get(data, ['_data', 'categories', categoryIndex]);
    const card = get(category, ['categoryCards', productCardIndex]);

    this.props.trackModuleEvent({
      moduleType: MODULE_TYPES.CATEGORY_CAROUSEL,
      moduleName: get(card, 'internalName'),
      modulePosition: homepagePosition,
      imageName: get(card, ['image', 'title']),
      linkCTAName: label,
      linkDestination: url,
      carouselCardName: get(card, 'carouselCardName'),
      carouselCategoryName: get(category, 'categoryName'),
      carouselCardPosition: productCardIndex + 1,
    });
  };

  render() {
    const { data } = this.props;
    const { activeCategoryIndex, activeSlideIndex } = this.state;

    if (isEmpty(data.categories)) {
      return null;
    }

    return (
      <section className="CategoryCarousel">
        <div className="CategoryCarousel__title">
          <SecondaryHeading>{data.title}</SecondaryHeading>
        </div>
        <Small>
          <MobileCarousel
            categories={data.categories}
            handleSlideSelect={this.handleSlideSelect}
            handleCategorySelect={this.handleCategorySelect}
            activeCategoryIndex={activeCategoryIndex}
            activeSlideIndex={activeSlideIndex}
            trackCTAClick={this.trackCTAClick}
          />
        </Small>
        <Medium>
          <MobileCarousel
            categories={data.categories}
            handleSlideSelect={this.handleSlideSelect}
            handleCategorySelect={this.handleCategorySelect}
            activeCategoryIndex={activeCategoryIndex}
            activeSlideIndex={activeSlideIndex}
            trackCTAClick={this.trackCTAClick}
          />
        </Medium>
        <LargeUp>
          <DesktopCategories
            categories={data.categories}
            handleCategorySelect={this.handleCategorySelect}
            activeCategoryIndex={activeCategoryIndex}
            activeSlideIndex={activeSlideIndex}
            trackCTAClick={this.trackCTAClick}
          />
        </LargeUp>
        <style jsx>{`
          .CategoryCarousel {
            padding-bottom: ${Theme.get('spacing') * 5}px;
            height: 100%;
            overflow: hidden;
          }

          @media ${mediumUp} {
            .CategoryCarousel {
              padding-bottom: ${Theme.get('spacing') * 13}px;
            }
          }

          @media ${largeUp} {
            .CategoryCarousel {
              padding-bottom: ${Theme.get('spacing') * 8}px;
            }
          }

          .CategoryCarousel__title {
            text-align: center;
          }
        `}</style>
      </section>
    );
  }
}

CategoryCarousel.propTypes = {
  data: PropTypes.instanceOf(CategoryCarouselHero).isRequired,
  trackModuleEvent: PropTypes.func,
  homepagePosition: PropTypes.number,
};

CategoryCarousel.defaultProps = {
  trackModuleEvent: () => {},
  homepagePosition: null,
};

export default CategoryCarousel;
